module.exports = __webpack_public_path__ + "img/icon-call.1374717e.png";